import React, { useCallback } from 'react';

interface PhoneInputProps {
  value?: string;
  onChange: (event: { target: { value: string } }) => void;
  className?: string;
}

export function PhoneInput({ value = '', onChange, className }: PhoneInputProps) {
  const formatPhoneNumber = useCallback((input: string): string => {
    const digits = input.replace(/\D/g, '');
    const len = digits.length;

    if (len === 0) return '';
    if (len <= 3) return `(${digits}`;
    if (len <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  }, []);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const digits = inputValue.replace(/\D/g, '').slice(0, 10);

    onChange({
      target: {
        value: digits,
      },
    });
  }, [onChange]);

  const displayValue = formatPhoneNumber(value);

  return (
    <input
      type="text"
      value={displayValue}
      onChange={handleChange}
      placeholder="(___) ___-____"
      className={className}
      maxLength={14}
    />
  );
}
